import styled from 'styled-components';

export default styled.div`
  display: none;
  flex-grow: 1;
  font-size: 15px;
  margin-left: 10px;
  text-align: left;
`;
